import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../Layout/Layout";
import DropshippingInterneLayout from "../components/DropshippingInterneLayout";
import ProviderMarketplaceBrowser from "./ProviderMarketplaceBrowser";
import ProviderHome from "./ProviderHome";
import ProviderCatalog from "./ProviderCatalog";
import SellerSourcingHistorySection from "../history/RecentlyViewedSwipers";

// /seller/providers -> Provider Home (Buyer-Home style); ?providerId= -> that Provider's shop
// (same catalog engine as /seller/provider-catalog, scoped to the shop); ?view=list -> the
// complete providers list with its Filters panel.
const SellerProviderMarketplace = ({ infoSource }) => {
  const [searchParams] = useSearchParams();
  const providerId = searchParams.get("providerId");
  const [view, setView] = useState("grid");
  if (providerId) return <ProviderCatalog key={providerId} infoSource={infoSource} mode="shop" providerId={providerId} />;
  if (searchParams.get("view") !== "list") return <ProviderHome infoSource={infoSource} />;
  return <Layout infoSource={infoSource} titleElakay="providerProducerIn" SliderPunShow={false} loading={false} outOffPage={false} {...infoSource?.allSettings?.layout} showFooter={true}>
    <DropshippingInterneLayout infoSource={infoSource}>
      <ProviderMarketplaceBrowser view={view} setView={setView} />
      <div className="dsi-page"><SellerSourcingHistorySection infoSource={infoSource} /></div>
    </DropshippingInterneLayout>
  </Layout>;
};
export default SellerProviderMarketplace;
